import type { FileResponse } from '@abb-procure/api';
import { HttpResponse } from '@angular/common/http';

const getFileName = (response: HttpResponse<Blob>): string | null => {
  const contentDisposition = response.headers.get('Content-Disposition');

  if (!contentDisposition) {
    return null;
  }

  const fileNameParam = contentDisposition
    .split('; ')
    .find((part) => part.trim().startsWith('filename='));

  if (!fileNameParam) {
    return null;
  }

  return (
    /^filename=(.*)$/.exec(fileNameParam)?.[1]?.replace(/["']/g, '') ?? null
  );
};

export const downloadBlob = (blob: FileResponse, name: string): void => {
  if (!blob || typeof blob === 'string') {
    return;
  }

  const data = blob instanceof HttpResponse ? blob.body : blob;
  const fileName = blob instanceof HttpResponse ? getFileName(blob) : name;

  if (!data) {
    return;
  }

  const url = window.URL.createObjectURL(new Blob([data], { type: data.type }));
  const link = document.createElement('a');

  link.href = url;
  link.download = fileName ?? name;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
